import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';

function ThinkingDot() {
  return (
    <span className="inline-flex items-center gap-[3px] ml-1">
      <span className="w-1 h-1 rounded-full bg-gray-400 dark:bg-gray-500 animate-[pulse_1.4s_ease-in-out_infinite]" />
      <span className="w-1 h-1 rounded-full bg-gray-400 dark:bg-gray-500 animate-[pulse_1.4s_ease-in-out_0.2s_infinite]" />
      <span className="w-1 h-1 rounded-full bg-gray-400 dark:bg-gray-500 animate-[pulse_1.4s_ease-in-out_0.4s_infinite]" />
    </span>
  );
}

export default function ThinkingBlock({ thinking, done }) {
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (done) setExpanded(false);
  }, [done]);

  if (!thinking) return null;

  return (
    <div className="mb-3">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1.5 py-1 text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
      >
        <ChevronRight className={`w-3 h-3 transition-transform duration-200 ${expanded ? 'rotate-90' : ''}`} />
        <span>{done ? 'Thought process' : 'Thinking'}</span>
        {!done && <ThinkingDot />}
      </button>

      <div
        className={`grid transition-[grid-template-rows] duration-200 ease-out ${
          expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className="border-l border-gray-200 dark:border-gray-700 ml-1.5 pl-3 pt-1 pb-0.5 text-xs leading-relaxed text-gray-400 dark:text-gray-500 whitespace-pre-wrap break-words">
            {thinking}
          </div>
        </div>
      </div>
    </div>
  );
}
